import { render, staticRenderFns } from "./SpecialEditComment.vue?vue&type=template&id=1aa9b876&scoped=true&lang=html"
import script from "./SpecialEditComment.vue?vue&type=script&lang=js"
export * from "./SpecialEditComment.vue?vue&type=script&lang=js"
import style0 from "./SpecialEditComment.vue?vue&type=style&index=0&id=1aa9b876&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9b876",
  null
  
)

export default component.exports